module.exports = (function(){
    
  var collections = {};
  var stores = [];
  var blogs = {};
  var pendings = [];
  var callbacks = {};
  var collectionInfo = {};
  var pages = {};
  var cart = {};
  var addToCartCallback = null;

  var getCollectionRec = function(path, page, collection, result, callback, cbFirstBatch) {
  
    jQuery.get(path + "?page=" + page,

      function(response) {

        if (cbFirstBatch) {
          collections[collection] = response.products;
          cbFirstBatch(_.clone(response.products));
        }
        if (0 == response.products.length) {
          collections[collection] = collections[collection] ? collections[collection].concat(result) : result;
          if (!cbFirstBatch) {
            callback(_.clone(result));
          }
        } else {
          getCollectionRec(path,
                           page + 1, 
                           collection,
                           cbFirstBatch ? [] : result.concat(response.products),
                           callback,
                           null); 
        }
    });
  };

  var getCollection = function(collection, callback, cbFirstBatch) {
  
    var allGot = function(result, collection) {
      callback(result);
    };

    if (undefined != collections[collection]) {
      if (cbFirstBatch) {
        cbFirstBatch(collections[collection], true);
      } else {
        callback(collections[collection]);
      }
    } else {
      getCollectionRec("/collections/" + collection + "/products.json",
                       1,
                       collection,
                       [],
                       function(result) { allGot(result, collection); },
                       cbFirstBatch);
    }
  };

  var getFeatureProd = function(callback) {
    getCollection("featured", callback);
  };

  var getSpecialPost = function(blogName, callback, single) {
    single = (typeof(single) === 'undefined') ? true : single;

    if (blogs[blogName]) {
      if (single) {
        var article = blogs[blogName]["articles"][0];

        callback({ title: article.title,
                   content: article.content });
      } else {
        callback(blogs[blogName]["articles"]);
      }
    } else {
      jQuery.get("/blogs/" + blogName,
        function(result) {
           var blog = JSON.parse(result);
           
           blogs[blogName] = blog;
           if (single) {
             callback({ title: blog["articles"][0].title,
                        content: blog["articles"][0].content});
           } else {
             if ("none" == blog.next) {
               callback(blog["articles"]);
             } else {
               getBlogRec(blogName, callback);
             }
           }
        }.bind(this));
    }
  };

  var getBlogRec = function(blogName, callback) {
    jQuery.get("/blogs/" + blogName,
        function(result) {
           var blog = JSON.parse(result);
           
           blogs[blogName]["articles"] = blogs[blogName]["articles"].concat(blog.articles);
           if (blog.next == "none") {
             callback(blogs[blogName]["articles"]);
           } else {
             getBlogRec(blogName, callback);
           }
        });
  };

  var getPostByHandle = function(blogName, handle, callback) {
    if (blogs[blogName]) {
      callback(_.filter(blogs[blogName].articles,
                        function(post) {
                          return post.url.indexOf(handle) > 0;
                        })[0]);
    } else {
      jQuery.get("/blogs/" + blogName + "/" + handle,
        function(result) {
          callback(JSON.parse(result));
        }.bind(this));
    }
  };

  var getBlog = function(blogName, callback) {
    getSpecialPost(blogName, callback, false);
  };

  var getCollectionInfo = function(collection, callback) {
    if (collectionInfo[collection]) {
      callback(collectionInfo[collection]);
    } else {
      jQuery.get("/collections/" + collection + ".json",
        function(result) {
          collectionInfo[collection] = result.collection;
          callback(result.collection);
        });
    }
  };

  var getSingleProduct = function(prodHandle, callback) {

    jQuery.get("/products/" + prodHandle + ".json",
        function(result) {
            callback(result.product);
        });
  };

  var cartOp = function(url, prodId, qty, callback) {

    jQuery.ajax({ url: url,
                  type: "POST",
                  dataType: "json",
                  contentType: "application/json;charset=UTF-8",
                  data: '{"id": ' + prodId + ', "quantity": ' + qty + '}',
                  success: function(result) {
                    callback(true, result);
                  },
                  error: function(err) {
                    callback(false, err.responseJSON.description);
                  },
                  complete: function(hdr, status) {
                    console.log(status);
                  } });
  };

  var addToCart = function(prodId, qty, callback) {
    addToCartCallback = callback;
    cartOp("/cart/add.js", prodId, qty, callback);
  };

  var adjustCartLineQty = function(prodId, qty, callback) {

    jQuery.ajax({ url: "/cart/change.js",
                  type: "POST",
                  dataType: "json",
                  contentType: "application/json;charset=UTF-8",
                  data: '{"id": "' + prodId + '", "quantity": "' + qty + '"}',
                  success: function(result) {
                    callback(true, result);
                  },
                  error: function(err) {
                    callback(false, err.responseJSON.description);
                  },
                  complete: function(hdr, status) {
                    console.log(status);
                  } });
    //cartOp("/cart/change.js", prodId, qty, callback);
  };

  var getCartContent = function(callback) {
    jQuery.get("/cart.json", function(result) {
      cart = result;
      callback(result);
    });
  };

  var getPage = function(page, callback) {
    if (pages[page]) callback(pages[page]);
    else {
      jQuery.get("/pages/" + page, function(result) {
        var p = JSON.parse(result);

        pages[page] = p;
        callback(p);
      }.bind(this));
    }
  };

  var search = function(terms, callback) {
    jQuery.get("/search?q=" + terms + "&type=product", function(result) {
      callback(JSON.parse(result));
    })
  };

  return { getCollection: getCollection,
           getFeatureProd: getFeatureProd,
           getSpecialPost: getSpecialPost,
           getBlog: getBlog,
           getPostByHandle: getPostByHandle,
           getCollectionInfo: getCollectionInfo,
           getSingleProduct: getSingleProduct,
           addToCart: addToCart,
           getCartContent: getCartContent,
           adjustCartLineQty: adjustCartLineQty,
           search: search }
})();